package io.github.jangalinski.pages._2014._09._30

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initStartingWithDropwizardPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2014/09/30/StartingWithDropwizard.md", FrontMatterElement.Builder { addScalar("title", "Starting with dropwizard"); addScalar("description", "some useful links"); addScalar("header-img", "/img/about-bg.jpg"); addScalar("date", "2014-09-30"); }))
}

@Page("/2014/09/30/starting-with-dropwizard")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun StartingWithDropwizardPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("starting-with-dropwizard") }) {
        org.jetbrains.compose.web.dom.Text("Starting with dropwizard")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After watching the project for a while, I decided to create my first dw application.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("useful-links") }) {
        org.jetbrains.compose.web.dom.Text("Useful links")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://www.openshift.com/blogs/day-13-dropwizard-the-awesome-java-rest-server-stack") {
                org.jetbrains.compose.web.dom.Text("The awesome Java/REST server stack")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://groups.google.com/forum/#!topic/camunda-bpm-users/YXoH1LaWMGQ") {
                org.jetbrains.compose.web.dom.Text("Discussion camunda on dropwizard")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://wiki.fasterxml.com/JacksonUpgradeFrom19To20") {
                org.jetbrains.compose.web.dom.Text("Jackson 1.9 to 2.3?")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://www.cowtowncoder.com/blog/archives/2012/04/entry_469.html") {
                org.jetbrains.compose.web.dom.Text("notes for jackson migration")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/camunda/camunda-bpm-examples/tree/master/deployment/embedded-spring-rest") {
                org.jetbrains.compose.web.dom.Text("embedded REST/Spring camunda")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("http://eureka.ykyuen.info/2010/07/26/jetty-stop-a-jetty-server-by-command/") {
                org.jetbrains.compose.web.dom.Text("controlled shutdown of jetty")
            }
        }
    }
}
